export default __webpack_public_path__ + "static/media/qr-templated-gas95.bbb6f306.png";